import React from 'react'
import TextField from './TextField'

const SectionFormFields = ({form, formFields,section, showSection, onSubmit, updateData}) => {

    return (
        <>
       
            {(!form?.isOfficialFilled ) && <div className="border-b mb-8 mt-8 flex justify-start pl-2.5 h-[50px] items-center radius border-[gainsboro] "><div className="">{section?.name}</div></div>}
            {(!form?.isOfficialFilled ) && <form onSubmit={onSubmit} className="grid grid-cols-1" >
                <div className="grid grid-cols-3">
                    {formFields?.map((formField, _idx) => <div key={_idx} className="my-2 flex justify-between items-start h-[70px] w-[95%] ">
                        <TextField
                            options={formField?.formFieldOptions}
                            id={formField?.formFieldId}
                            type={formField?.formFieldType?.fieldTypeName}
                            label={formField?.label}
                            name={formField?.label}
                            value={formField?.value}
                            required={formField?.required}
                            onChange={updateData} /></div>)}
                </div>
                <div className="flex justify-end items-end">
                    <button type="submit" className=" bg-[#0E86D4] text-white font-medium px-8 py-2 text-md rounded print:hidden " >Submit</button>
                </div>
            </form>}
        </>
    )
}

export default SectionFormFields